import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { DATATRANSFER_INIT_LOADING, DATATRANSFER_INIT_SUCCESS, DATATRANSFER_INIT_FAIL } from '@/store/types'

export const dataTransfer = {
  async dataTransferInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.dataTransfer
    commit(DATATRANSFER_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(DATATRANSFER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(DATATRANSFER_INIT_FAIL, extractMessages(error))
    }
  }
}
